import styled from 'styled-components';

import { Text } from '../../../components/core';

type ContentProps = {
  position: 'left' | 'right'
}

const ScreenHalfContentContainer = styled.div`
  position: absolute;
  bottom: 64px;
  left: 0;

  max-width: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .header-container {
    margin-bottom: 22px;
    width: 80%;
  }

  .white-line {
    width: 0%;
    border: 1px solid white;
    height: 1px;
    margin-bottom: 22px;
  }

  .body-container {
    width: 80%;
    margin-bottom: 48px;
    .text-container {
      max-width: 540px;
      margin-left: 0px;
      margin-right: 10%;
    }
  }

  ${({ position }: ContentProps) => {
    switch (position) {
      case 'right':
        return `
          left: auto;
          right: 0;

          align-items: flex-start;

          .header-container {
            text-align: right;
          }

          .body-container {
            text-align: right;
              .text-container {
                margin-left: 10%;
                margin-right: 0px;
              }
            }
          }
        `;
    }
  }}
`;

type Props = {
  position: 'left' | 'right'
  header: string[]
  body: string
}

const ScreenHalfContent = ({ position, header, body }: Props) => {
  return (
    <ScreenHalfContentContainer position={position}>
      <div className='header-container'>
        {
          header.map(text => <Text className='fadeInUp' variant='Header2'>{text}</Text>)
        }
      </div>
      <div style={{[position === 'left' ? 'marginRight' : 'marginLeft']: 'auto'}} className='white-line growFull'></div>
      <div className='body-container'>
        <div className='text-container'>
          <Text className='fadeInUp' variant='Body1'>{body}</Text>
        </div>
      </div>
    </ScreenHalfContentContainer>
  );
};

export default ScreenHalfContent;